export const createMultipartFormData = (file, advisorId) => {
    const formData = new FormData();
    formData.append("file", file);
    if (advisorId !== undefined) {
        formData.append("advisorId", advisorId);
    }
    return formData;
};
//# sourceMappingURL=createMultipartFormData.js.map